// File: frontend/src/pages/Capabilities/components/VideoShowcase.js

import React from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import { Play } from 'lucide-react';
import styles from './VideoShowcase.module.css';

const VideoShowcase = ({ videos, onOpenVideo }) => {
  return (
    <div className={styles.container}>
      <div className={styles.grid}>
        {videos.map((video, index) => (
          <motion.div
            key={video.id}
            className={`${styles.card} ${styles[`featured${index + 1}`]}`}
            whileHover={{ 
              scale: 1.03, 
              zIndex: 10,
              boxShadow: '0 20px 40px rgba(0, 0, 0, 0.4)'
            }}
            whileTap={{ scale: 0.98 }}
            onClick={() => onOpenVideo(video)}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ 
              delay: index * 0.1,
              duration: 0.5,
              ease: "easeOut"
            }}
          >
            <div className={styles.cardVideoContainer}>
              <img 
                src={video.poster} 
                alt={video.title} 
                className={styles.cardPoster}
              />
              <div className={styles.playIconWrapper}>
                <div className={styles.playButton}>
                  <Play className={styles.playIcon} />
                </div>
              </div>
              <div className={styles.titleOverlay}>
                <span className={styles.cardTitle}>{video.title}</span>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

VideoShowcase.propTypes = {
  videos: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      src: PropTypes.string.isRequired,
      poster: PropTypes.string.isRequired
    })
  ).isRequired,
  onOpenVideo: PropTypes.func.isRequired
};

export default VideoShowcase;